import { X } from 'lucide-react';
import type { FormSubmissionWithAnswers } from '../../types/forms';

interface SubmissionAnswersModalProps {
  submission: FormSubmissionWithAnswers;
  onClose: () => void;
}

export function SubmissionAnswersModal({ submission, onClose }: SubmissionAnswersModalProps) {
  const formatDate = (dateString: string) => {
    return new Date(dateString).toLocaleString('de-DE', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
    });
  };

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center p-4 !mt-0">
      <div className="absolute inset-0 bg-black/20 backdrop-blur-sm" onClick={onClose} />
      <div className="relative bg-white rounded-2xl shadow-xl w-full max-w-lg overflow-hidden max-h-[80vh] flex flex-col">
        <div className="flex items-center justify-between px-6 py-4 border-b border-gray-100">
          <div>
            <h2 className="text-lg font-semibold text-gray-900">
              Formularantworten
            </h2>
            <p className="text-sm text-gray-500">
              {submission.form?.name || 'Formular'} - {formatDate(submission.submitted_at)}
            </p>
          </div>
          <button
            onClick={onClose}
            className="p-2 text-gray-400 hover:text-gray-600 rounded-lg hover:bg-gray-100"
          >
            <X className="w-5 h-5" />
          </button>
        </div>

        <div className="flex-1 overflow-auto p-6 space-y-4">
          {submission.answers.length === 0 ? (
            <p className="text-gray-500 text-center py-4">
              Keine Antworten vorhanden
            </p>
          ) : (
            submission.answers
              .sort((a, b) => (a.field?.field_order || 0) - (b.field?.field_order || 0))
              .map((answer) => (
                <div key={answer.id} className="border-b border-gray-100 pb-4 last:border-0">
                  <p className="text-sm font-medium text-gray-700 mb-1">
                    {answer.field?.label || 'Feld'}
                  </p>
                  <p className="text-gray-900 whitespace-pre-wrap">
                    {answer.value || <span className="text-gray-400 italic">Keine Angabe</span>}
                  </p>
                </div>
              ))
          )}
        </div>

        <div className="px-6 py-4 border-t border-gray-100">
          <button
            onClick={onClose}
            className="w-full py-2.5 bg-gray-100 text-gray-700 rounded-xl hover:bg-gray-200 transition-colors font-medium"
          >
            Schließen
          </button>
        </div>
      </div>
    </div>
  );
}
